import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { hiltonHeadConfig } from "./data";

export default function HiltonHeadPage() {
  return <CityPageTemplate config={hiltonHeadConfig} />;
}